import { enumSchema } from "vue-utils"

export enum MarriageValidity {
	Valid = "Valid",
	ContactLater = "ContactLater",
	Invalid = "Invalid",
}

export const MarriageValiditySchema = enumSchema(MarriageValidity)
